import ReactDOM from 'react-dom/client'
import * as Sentry from "@sentry/react";
import App from './App.jsx'
import './styles/index.css'
import { migrateStorage } from './utils/userData'
import { initMixpanel } from './utils/mixpanel'
import { initGoogleAnalytics } from './utils/googleAnalytics'

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://b4586e09d420eae261a8c2b764fda473@o4510826238509056.ingest.de.sentry.io/4510826244472912",
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    // BEHAVIOUR CHANGE (2026-10-09, perf work): was 1.0. Only 10% of page
    // loads now produce a performance trace. Errors are still captured 100%;
    // Session Replay sampling below is unchanged. Raise if Sentry Performance
    // dashboards look too sparse.
    tracesSampleRate: 0.1,
    // The API is same-origin (/api proxied by nginx), so propagate trace headers
    // to relative /api calls and to localhost in dev builds.
    tracePropagationTargets: ["localhost", /^\/api\//],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true
  });

  // Session Replay is the heaviest Sentry integration (~260 KB + a
  // MutationObserver on every DOM change). Load it from Sentry's CDN after
  // the app is up rather than shipping it in the entry chunk.
  Sentry.lazyLoadIntegration('replayIntegration')
    .then((replayIntegration) => Sentry.addIntegration(replayIntegration()))
    .catch(() => { /* replay is best-effort */ })
}

// Migrate legacy auth tokens to unified token key on app start
migrateStorage()

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>,
)

// Product analytics are not needed for first paint. Start them once the
// browser is idle so they do not compete with rendering, the event API call
// and the Meta Pixel on slow phones. trackEvent() calls made before Mixpanel
// finishes loading are buffered and replayed.
const whenIdle = (cb) =>
  typeof window.requestIdleCallback === 'function'
    ? window.requestIdleCallback(cb, { timeout: 3000 })
    : window.setTimeout(cb, 1500)

whenIdle(() => {
  initMixpanel()
  initGoogleAnalytics()
})
